import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { MultipleImageUploader, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";
import Constants from "constants/index";

import { Mode } from "constants/enum";
import { IDataDetailAnalysis } from "commons/interfaces";



export const CardImageFishboneDiagrams = ({
    mode,
    dataAnalysis,
    handleChangeValue,
}: {
    mode: Mode,
    dataAnalysis: IDataDetailAnalysis;
    handleChangeValue: (key: string, value: any) => void;
}) => {
    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.ANALYSIS.IMAGE_FISHBONE_DIAGRAM}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <MultipleImageUploader
                        mode={mode}
                        folderPath={Constants.CloudStorage.FISHBONE_DIAGRAM}
                        defaultValue={[...dataAnalysis?.fishboneDiagramUrls || []]}
                        onChange={(value) => {
                            handleChangeValue("fishboneDiagramUrls", value);
                        }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
};

export default CardImageFishboneDiagrams;
